import React, { useRef, useEffect} from 'react';
import './DeveloperSupport.css'

function DeveloperSupport({setIsVisible}) {

     // ******************* Observe if the component is loaded in the viewport **************

     const targetRef = useRef(null);
  
     useEffect(() => {
       const observer = new IntersectionObserver(
         ([entry]) => {
           // entry.isIntersecting is true when the target element is visible
           if(entry.isIntersecting){
              setIsVisible("developer-support");
           }
         },
         {
           root: null, // use the viewport as the root
           rootMargin: '0px', // no margin
           threshold: 0.5, // 0.5 means at least 50% of the target element must be visible
         }
       );
   
       if (targetRef.current) {
         observer.observe(targetRef.current);
       }
   
       // Cleanup the observer when the component is unmounted
       return () => {
         if (targetRef.current) {
           observer.unobserve(targetRef.current);
         }
       };
     }, []);
   

     

    return (
        <div ref={targetRef} id='developer_support'>
            <div className='developer_support_side_text'>
                <h1>👩‍🏫 Developer Support</h1>
                <p>As Developers we understand that no API Reference can answer every question.</p>
                <p>We have a Developer to Developer support system where if you are working with our API you can speak directly to a developer.</p>
                <p>If you have a question about our API just start a conversation with us using the chat widget on this page or via contact@sheildscan.com.</p>
            </div>
            <div className='developer_support_side_code'>
            </div>
        </div>
    )
}

export default DeveloperSupport
